import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../assets/fonts/cyrene.woff2%22,%22variable%22:%22--font-cyrene%22,%22weight%22:%22400%22,%22display%22:%22swap%22}],%22variableName%22:%22cyrene%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'cyrene', 'cyrene Fallback'",
        fontWeight: 400,

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
